import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RecaptchaComponent } from 'ng-recaptcha';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { IBasicInfo, IFundraiser } from '../../../../fundraiser/models/fundraiser.model';
import { IUser } from '../../../../shared/models/user.model';
import { EventsService, FundraiserService, SignupService, UtilService, VariablesService, VwoService } from '../../../../shared/services';
import { update_type } from './update-type';
@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss'],
})
export class UpdateComponent implements OnInit, OnChanges, OnDestroy {

  @Input() config;
  // @Input() public customTag;
  @Input() public fundraiser: IFundraiser;
  @Input() public basicInfo: IBasicInfo;
  @Input() public isFundraiserEnded;
  @Input() public updates;
  @Input() public updateCounts;
  @Input() public latestUpdate;
  @Input() public viewMore;
  @Input() public pageName: string;
  @Input() public updateReact;
  @Input() public sharedCounts;
  @Input() public isDonated;
  @Input() public customTag;
  @Input() public updateOnly;
  @Input('urlParams') public param?;
  @Input() public showImpactCard?;
  @Input() public showComments = true;
  @Input() public currency;
  @Input() public showMoreBtn;
  @Input() public showCommentList = false;
  @Input() showSocialShare;
  @Input() likes = true;

  @Output() public viewMoreUpdates = new EventEmitter<any>();
  @Output() public commentPosted = new EventEmitter<any>();
  @Output() public CommentVisible = new EventEmitter<any>();
  @Output() public monthlyCardVisible = new EventEmitter<any>();

  @ViewChild('updateContainer') public updateContainer: ElementRef;
  @ViewChild('captchaRef') public captchaRef: RecaptchaComponent;

  isLoggedIn;
  fbShares;
  page = 2;
  comments;
  campaignId;
  updateType = update_type;
  userdata: IUser;
  isAskedForUpdate;
  isNotDonated;
  campaign;
  isMobile: any;
  // Subscriptions
  userdataSubs: Subscription;
  isLoggedInSubs: Subscription;
  showOffer = false;
  @ViewChild('loginPopupTemp') loginPopupTemp: ElementRef<HTMLElement>;

  constructor(
    public fundraiserService: FundraiserService,
    public variablesService: VariablesService,
    public utilService: UtilService,
    public signupService: SignupService,
    public actRoute: ActivatedRoute,
    public vwo: VwoService,
    public eventsService: EventsService,
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    // this.utilService.addCssToGlobal('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');

    this.campaign = this.variablesService.campaignType;
    if (this.pageName !== 'updatesPage' && this.fundraiser) {
      this.campaignId = this.fundraiser.id;
    } else if (this.pageName === 'updatesPage' && this.updates.data.length) {
      this.campaignId = this.updates.data[0].entity_id;
    }
    this.isLoggedInSubs = this.utilService.isLoggedIn$.subscribe(res => this.isLoggedIn = res);
    this.userdataSubs = this.variablesService.userData.subscribe(res => this.userdata = res);
  }
  /**Open Modal/Dialog */
  openFacebookLogin() {
    this.signupService.openSignUp(this.loginPopupTemp, 'otp', () => { });
  }
  ngOnChanges(changes: SimpleChanges) {
    // tslint:disable-next-line:max-line-length
    if (changes['updateReact'] && changes['updateReact'].firstChange !== true && changes['updateReact'].currentValue !== changes['updateReact'].previousValue) {
      this.reactOnUpdate(this.updates.data[0]);
    }
  }
  /**Set the color property */
  getColor(updtype) {
    return updtype ? this.updateType[updtype].color : this.updateType.quick.color;
  }
  /**Get the Update type label*/
  getUpdateTypeLabel(updtype) {
    return updtype ? this.updateType[updtype].label : this.updateType.quick.label;
  }
  /**Get the Update type icon*/
  getUpdateTypeIcon(updtype) {
    return updtype ? this.updateType[updtype].icon : this.updateType.quick.icon;
  }
  /**Get the Update type icon*/
  getUpdateTypeReaction(updtype, reacted) {
    if (reacted) {
      return updtype ? this.updateType[updtype].filled : this.updateType.quick.filled;
    } else {
      return updtype ? this.updateType[updtype].reaction : this.updateType.quick.reaction;
    }
  }
  /**toggle the reation */
  reactOnUpdate(update) {
    if (this.isLoggedIn) {
      const payload = {
        'status': update.user_liked.status === 1 ? 0 : 1
      };

      this.fundraiserService.postUpdateLikes(update.entity_id, update.id, payload).subscribe((res: any) => {
        if (update.likes_count) {
          // tslint:disable-next-line:max-line-length
          update.user_liked.status === 0 ? (update.likes_count.count++, update.user_liked.status = 1) : (update.likes_count.count--, update.user_liked.status = 0);
        } else {
          update.likes_count = { count: 1 };
          update.user_liked.status = 1;
        }
      });
    } else {
      this.openFacebookLogin();
    }
  }
  /**Set the Charater to paragrapg case */
  setTitleCase(title: string) {
    return title.charAt(0).toUpperCase() + title.substr(1);
  }
  getIsAskedForUpdate(data) {
    this.isAskedForUpdate = data;
  }
  getIsNotDonated(data) {
    this.isNotDonated = data;
  }
  /**send the click event to child component */
  askUpdateClickListner(_el: any) {
    if (_el.children[0]) {
      _el.children[0].children[0].children[0].click();
    }
  }
  /**Load more update if there any */
  loadUpdate() {
    if (this.pageName.match('updatesPage|story')) {
      this.viewMoreUpdates.emit(true);
    } else if (this.updateCounts > 2) {
      this.getFundraiserUpdates(this.fundraiser.custom_tag, 2);
    }
  }
  getCommentLength(comments) {
    return comments && (comments?.total || comments.length) ?  (comments?.total || comments.length) : 0;
  }
  /**Feedback for successfull post comment */
  isCommentPosted(event) {
    this.commentPosted.emit(true);
  }

  /**Check whether post comment is visible on screen or not */
  isCommentVisible(event) {
    this.CommentVisible.emit(event);
  }
  /**Get fundraiser updates */
  getFundraiserUpdates(customTag, limit) {
    const qParam = `?with=owner.avtar;comments&limit=${limit}&page=${this.page}&orderBy=creation_time&sortedBy=desc`;
    this.fundraiserService.getFundraiserUpdates(customTag, qParam).subscribe((res: any) => {
      this.page++;
      for (let i = 0; i < res.data.data.length; i++) {
        if (res.data.data[i].owner) {
          res.data.data[i].owner['creation_time'] = res.data.data[i].creation_time;
        }
        if (!res.data.data[i].user_liked) {
          res.data.data[i].user_liked = { 'status': 0 };
        }
        const qParam1 = `/${res.data.data[i].id}/comments?limit=5`;
        this.fundraiserService.getFundraiserUpdates(customTag, qParam1).subscribe((res1: any) => {
          res.data.data[i]['comments'] = res1.data;
          res.data.data[i]['comments'].placeholder = 'Write something to cheer ' + this.fundraiser.campaigner.fname;
        });
        res.data.data[i]['comments'].placeholder = 'Write something to cheer ' + this.fundraiser.campaigner.fname;
        this.updates.data.push(res.data.data[i]);
        this.updates.next_page_url = res.data.next_page_url;
      }
    });
  }

  commentCountClick(update) {
    this.showComments = true;
    if (!this.showCommentList) {
      this.updateShowCommentList(update);
    }
  }

  updateShowCommentList(update) {
    this.updates.data = this.updates.data.map(data => {
      if (data.id === update.id) {
        data.showCommentList = true;
      }
      return data;
    });
  }

  sipPitchVisible(e) {
    this.monthlyCardVisible.next(e);
    if (
      !this.showOffer &&
      e.visible &&
      this.userdata &&
      !this.userdata?.listsubscriptions?.medical &&
      this.currency === 'INR' &&
      !this.actRoute.snapshot.queryParams.offer
    ) {
      this.showOffer = true;
    }
  }

  readMoreClicked() {
    this.showMoreBtn = false;
    this.eventsService.sendSystemEvent({
      eventName: 'update_page_read_more',
      info_3: this.variablesService.campaignType,
      page_name: this.variablesService.pageName
    }).subscribe(_ => _);
  }

  ngOnDestroy() {
    if (this.userdataSubs) { this.userdataSubs.unsubscribe(); }
    if (this.isLoggedInSubs) { this.isLoggedInSubs.unsubscribe(); }
  }

}
